import { Post, Get, Put, Delete } from "@/utils";
import { ApiPath } from "@/enums";

export default {
  namespaced: true,
  state: {
    current_user: null,
    zipCodes: [],
    current_apprentice_criteria: {
      id: null,
      subjectArea: null,
      level: null,
      pathway: null,
      sgaHiddenExtras: {},
      sgaKnowledge: {},
      sgaSkills: {},
      sgaMindset: {}
    }
  },
  mutations: {
    SET_USER(state, payload) {
      state.current_user = payload;
    },
    SET_ZIPCODES(state, payload) {
      state.zipCodes = payload;
    }
  },
  actions: {
    // TODO: to be replaced with userAuthentication.methods.userLoggedIn() in view layer
    isLogged() {
      return axios.get(`${process.env.VUE_APP_API_BASE_URI}identity/Login`);
    },
    async validateexistinginterests({ }, body) {
      const { data: userInterests } = await Post(
        `${ApiPath.Apprentice}/validateexistinginterests`,
        body
      );
      return userInterests;
    },
    async createuserinterestscriteria({ }, criteria) {
      const { data: userInterestCreated } = await Post(
        `${ApiPath.UserInterest}/createuserinterestscriteria`,
        criteria
      );
      return userInterestCreated;
    },
    async updateuserinterestscriteria({ }, criteria) {
      const { data: userInterestUpdated } = await Put(
        `${ApiPath.UserInterest}/updateuserinterestscriteria`,
        criteria
      );
      return userInterestUpdated;
    },
    async getuserinterestcriteria({ }, criteria) {
      const { data: userInterestCriteria } = await Get(
        `${ApiPath.UserInterest}/getuserinterestcriteria`,
        criteria
      );
      return userInterestCriteria;
    },
    async deleteuserinterestcriteria({ }, criteriaId) {
      const { data: userInterestCriteria } = await Delete(
        `${ApiPath.UserInterest}/deleteuserinterestcriteria`,
        {
          params: { criteriaId }
        }
      );
      return userInterestCriteria;
    },
    async isprofilecreated({ }) {
      const { data: profileCreated } = await Get(
        `${ApiPath.Apprentice}/isprofilecreated`
      );
      return profileCreated;
    },
    async getuserinterestcriteriadetail({ }, criteriaId) {
      const { data: userInterestCriteriaDetail } = await Get(
        `${ApiPath.UserInterest}/getuserinterestcriteriadetail?criteriaId=${criteriaId}`,
        criteriaId
      );
      return userInterestCriteriaDetail;
    },
    async getSubjectAreas({ }) {
      const { data: subjectAreas } = await Get(
        `${ApiPath.SubjectArea}/getSubjectAreas`,
        null
      );
      return subjectAreas;
    },
    async getPathways({ }, subjectAreaId) {
      const { data: pathways } = await Get(
        `${ApiPath.Pathway}/getPathways?subjectAreaId=${subjectAreaId}`,
        null
      );
      return pathways;
    },
    async getLevelsWithCriteria({ }, subjectAreaId) {
      const { data: pathways } = await Get(
        `${ApiPath.Level}/getlevelswithcriteria?subjectAreaId${subjectAreaId}`,
        null
      );
      return pathways;
    },
    async sendInterestToCompany({ }, body) {
      const { data: interestSent } = await Post(
        `${ApiPath.Apprentice}/sendInterestToCompany`,
        body
      );
      return interestSent;
    },
    async getAppliedForApprenticeshipRoles({ }, apprenticeId) {
      const { data: appliedApprenticeshipRoles } = await Get(
        `${ApiPath.Apprentice}/getappliedforapprenticeshiproles?apprenticeId=${apprenticeId}`
      );
      return appliedApprenticeshipRoles;
    },
    async getInterestedCompanies({ }, request) {
      const { data: interestedCompanies } = await Get(
        `${ApiPath.Apprentice}/getinterestedcompanies?status=${request.status}`
      );
      return interestedCompanies;
    },
    async acceptCompanyInvitationToConnect({ }, request) {
      const { data: companyInvitationAccepted } = await Put(
        `${ApiPath.Apprentice}/acceptCompanyInvitationToConnect`,
        request
      );
      return companyInvitationAccepted;
    },
    async declineCompanyInvitationToConnect({ }, request) {
      const { data: companyInvitationDeclined } = await Put(
        `${ApiPath.Apprentice}/declineCompanyInvitationToConnect`,
        request
      );
      return companyInvitationDeclined;
    },
    async acceptApprenticeshipOffer({ }, request) {
      const { data: apprenticeshipOfferAccepted } = await Put(
        `${ApiPath.Apprentice}/acceptApprenticeshipOffer`,
        request
      );
      return apprenticeshipOfferAccepted;
    },
    async declineApprenticeshipOffer({ }, request) {
      const { data: apprenticeshipOfferDeclined } = await Put(
        `${ApiPath.Apprentice}/declineApprenticeshipOffer`,
        request
      );
      return apprenticeshipOfferDeclined;
    },
    async getRoleMatches(
      { commit },
      {
        apprenticeUserId,
        weighting,
        distance,
        certificate,
        pageCount,
        percentage
      }
    ) {
      const { data: roleMatches } = await Get(
        `${ApiPath.RoleMatching}/getapprenticeshiproles?apprenticeUserId=${apprenticeUserId}&weighting=${weighting}&distance=${distance}&certificate=${certificate}&pageCount=${pageCount}&percentage=${percentage}`
      );
      commit("SET_SGA", roleMatches);
      return roleMatches;
    },
    authorizeSuperAdmin({ commit }, loggedInUserId) {
      const userid =
        sessionStorage.getItem("debugid") == null
          ? null
          : sessionStorage.getItem("debugid");
      return axios
        .get(
          `${process.env.VUE_APP_API_BASE_URI}identity/LoginSuperAdminToApprenticeApplication?userId=${loggedInUserId}`
        )
        .then(res => {
          localStorage.setItem("token", res.data);
          return axios
            .get(
              `${process.env.VUE_APP_API_BASE_URI}apprentice/apprenticeinfo?userid=${userid}`
            )
            .then(res => {
              commit("SET_USER", res.data);
              return res.data;
            });
        })
        .catch(res => {
          const errors = res.response;
          throw errors;
        });
    },
    checkEducationDetails() {
      const userid =
        sessionStorage.getItem("debugid") == null
          ? null
          : sessionStorage.getItem("debugid");
      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URI}common/checkeducationdetails?userid=${userid}&usertype=APPRENTICE`
        )
        .then(res => {
          return res;
        })
        .catch(res => {
          const errors = res.response;
          throw errors;
        });
    },
    async acceptApprenticeshipOffer({ }, request) {
      const { data: roleInfo } = await Put(
        `${ApiPath.Apprentice}/acceptapprenticeshipoffer`,
        request
      );
      return roleInfo;
    },
    async declineApprenticeshipOffer({ }, request) {
      const { data: roleInfo } = await Put(
        `${ApiPath.Apprentice}/declineapprenticeshipoffer`,
        request
      );
      return roleInfo;
    }
  }
};
